import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgFitCenter = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M6.071 4.443h13.02c.116 0 .21-.1.21-.224V2.658c0-.123-.094-.224-.21-.224H6.071c-.115 0-.21.1-.21.224v1.561c0 .123.095.224.21.224Zm13.02 11.825c.116 0 .21-.1.21-.223v-1.562c0-.123-.094-.223-.21-.223H6.071c-.115 0-.21.1-.21.223v1.562c0 .123.095.223.21.223h13.02Zm3.78 3.905H2.291c-.115 0-.21.1-.21.223v1.562c0 .123.095.223.21.223h20.58c.116 0 .21-.1.21-.223v-1.562c0-.123-.094-.223-.21-.223Zm0-11.826H2.291c-.115 0-.21.1-.21.223v1.562c0 .123.095.223.21.223h20.58c.116 0 .21-.1.21-.223V8.57c0-.122-.094-.223-.21-.223Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgFitCenter)
const Memo = memo(ForwardRef)
export default Memo
